import { Component, Input, OnInit } from '@angular/core';
import { AppTab } from '../../core/app-tab';
import { ShowRequest } from '../../core/show-request';

@Component({
  selector: 'app-dialer-call-logs',
  templateUrl: './dialer-call-logs.component.html'
})
export class DialerCallLogsComponent implements OnInit {

  //
  // These @Input values get passed in from home.html and passed to the table component
  //

  @Input() tabConfig: AppTab;

  @Input() detailFn: (vi: ShowRequest) => void;

  @Input() isActiveView: boolean

  @Input() contextJson: string;

  @Input() contextJsonChangeHandler : (itemId: string,tab:AppTab) => void

  constructor() { }

  ngOnInit(): void {
  }

}
